<template>
  <path
    fill="none"
    stroke="#333333"
    stroke-width="1.5"
    d="M-1 12.5 h 4 l 6 -6 l 6 6 h 4"
  />
  <!-- <path d="M16 13H8V6H1V5H9V12H16V13Z"/> -->
</template>
